exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".product-shopping-quantity-input {\n  margin-right: 2%;\n  width: 4em;\n  display: inline-block; }\n\n.product-shopping-quantity-input-container {\n  width: 40em;\n  display: flex; }\n", ""]);

